type VersionEntry = {
  version: string;
  date: string;
  summary: string;
};

// When future revisions ship, prepend new entries here.
// Keep entries in reverse chronological order (newest first).
const VERSION_HISTORY: VersionEntry[] = [
  {
    version: "1.0",
    date: "April 24, 2026",
    summary: "Initial publication.",
  },
];

export function DirectiveVersionHistory() {
  return (
    <div className="mt-10">
      <h3 className="text-lg font-semibold mb-4">Version History</h3>
      <ul className="space-y-3 list-none pl-0 border-l-2 border-border">
        {VERSION_HISTORY.map((entry) => (
          <li key={entry.version} className="pl-4">
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span className="font-semibold">Version {entry.version}</span>
              <span className="text-sm text-muted-foreground">
                {entry.date}
              </span>
            </div>
            <p className="text-base text-muted-foreground mt-1">
              {entry.summary}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
